import { render } from "./BackgroundImage.vue?vue&type=template&id=0a39f03a"
import script from "./BackgroundImage.vue?vue&type=script&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&lang=js"

import "./BackgroundImage.vue?vue&type=style&index=0&id=0a39f03a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__